import { BLOCKCHAIN_NAME } from 'src/core/blockchain/models/blockchain-name';

import { AccrossCcrSupportedChains } from './across-ccr-supported-chains';

export const acrossContractAddresses: Record<AccrossCcrSupportedChains, string> = {
    [BLOCKCHAIN_NAME.ARBITRUM]: '0xe35e9842fceaca96570b734083f4a58e8f7c5f2a',
    [BLOCKCHAIN_NAME.BASE]: '0x09aea4b2242abC8bb4BB78D537A67a245A7bEC64',
    [BLOCKCHAIN_NAME.BLAST]: '0x2D509190Ed0172ba588407D4c2df918F955Cc6E1',
    [BLOCKCHAIN_NAME.ETHEREUM]: '0x5c7BCd6E7De5423a257D81B442095A1a6ced35C5',
    [BLOCKCHAIN_NAME.LINEA]: '0x7E63A5f1a8F0B4d0934B2f2327DAED3F6bb2ee75',
    [BLOCKCHAIN_NAME.MODE]: '0x3baD7AD0728f9917d1Bf08af5782dCbD516cDd96',
    [BLOCKCHAIN_NAME.OPTIMISM]: '0x6f26Bf09B1C792e3228e5467807a900A503c0281',
    [BLOCKCHAIN_NAME.POLYGON]: '0x9295ee1d8C5b022Be115A2AD3c30C72E34e7F096',
    [BLOCKCHAIN_NAME.SCROLL]: '0x3bad7ad0728f9917d1bf08af5782dcbd516cdd96',
    [BLOCKCHAIN_NAME.ZK_SYNC]: '0xE0B015E54d54fc84a6cB9B666099c46adE9335FF',
    [BLOCKCHAIN_NAME.SONEIUM]: '0x3baD7AD0728f9917d1Bf08af5782dCbD516cDd96',
    [BLOCKCHAIN_NAME.UNICHAIN]: '0x09aea4b2242abC8bb4BB78D537A67a245A7bEC64'
};
